import { useEffect, useState } from "react";

const POLICY_LANGUAGE_STORAGE_KEY = "bioindex-policy-language";

function detectPolicyLanguage() {
  if (typeof window === "undefined") return "en";

  try {
    const savedLanguage = window.localStorage.getItem(
      POLICY_LANGUAGE_STORAGE_KEY,
    );

    if (savedLanguage === "es" || savedLanguage === "en") {
      return savedLanguage;
    }
  } catch {
    // Language detection can continue without local storage.
  }

  const browserLanguages =
    navigator.languages?.length > 0
      ? navigator.languages
      : [navigator.language].filter(Boolean);

  return browserLanguages.some((browserLanguage) =>
    browserLanguage.toLowerCase().startsWith("es"),
  )
    ? "es"
    : "en";
}

export function usePolicyLanguage() {
  const [language, setLanguage] = useState(detectPolicyLanguage);

  useEffect(() => {
    try {
      window.localStorage.setItem(POLICY_LANGUAGE_STORAGE_KEY, language);
    } catch {
      // The selected language still works for the current page.
    }

    document.documentElement.lang = language;
  }, [language]);

  return [language, setLanguage];
}

export default function PolicyLanguageToggle({ language, onChange }) {
  const label =
    language === "es" ? "Seleccionar idioma" : "Select language";

  return (
    <div
      className="inline-flex rounded-xl border border-[#374049]/15 bg-white p-1 shadow-sm"
      role="group"
      aria-label={label}
    >
      {[
        { code: "es", label: "Español" },
        { code: "en", label: "English" },
      ].map((option) => {
        const selected = language === option.code;

        return (
          <button
            key={option.code}
            type="button"
            onClick={() => onChange(option.code)}
            aria-pressed={selected}
            className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition sm:text-sm ${
              selected
                ? "bg-[#374049] text-white shadow-sm"
                : "text-[#374049]/65 hover:bg-[#93CA87]/15 hover:text-[#374049]"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
